<template>
  <div class="evaluate">
    <page-title v-bind:title="'Rate ideas'"></page-title>
    <ideas-to-evaluate :listIds="listIds"></ideas-to-evaluate>    
  </div>
</template>

<script>
import bus from "../bus"

import IdeasToEvaluate from "../components/IdeasToEvaluate";
import PageTitle from "../components/PageTitle.vue";

export default {
  components: {
    IdeasToEvaluate,
    PageTitle
  },
  data() {
    return {
      userLists: []
    };
  },
  computed: {
    userListsStore() {
      return this.$store.state.userLists;
    },
    listIds() {
      let listIds = []
      for(let i in this.userLists){
        listIds.push(this.userLists[i].id)
      }
      return listIds
    }
  },
  watch: {
    userListsStore: {
      immediate: true,
      handler: function() {
        this.userLists = this.userListsStore;
      }
    }
  },
  beforeMount() {
    bus.$emit("show-loader", "");
  }
};
</script>

<style scoped lang="scss">
@use '@/styles/theme.scss';

.evaluate {
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  background-color: theme.$light-background;
  padding:  theme.$page-padding-top theme.$page-padding-X;
}
</style>